import { lazy, Suspense } from 'react';

import { Loading } from '../../design/components.js';
import type { ModuleWeb } from '../registry.js';

/**
 * Écrans du module Repas (spec 007) : espace bénévole simplifié « Mon repas », espace gestion
 * (suivi, relances, commandes) et administration des fournisseurs ; chargés à la demande.
 */
const page = <T extends string>(
  load: () => Promise<Record<T, () => React.ReactElement>>,
  name: T,
) => lazy(() => load().then((m) => ({ default: m[name] })));

const mine = () => import('./MonRepasPage.js');
const gestion = () => import('./RepasPages.js');
const MesRepasPage = page(mine, 'MesRepasPage');
const MonRepasPage = page(mine, 'MonRepasPage');
const RepasPage = page(gestion, 'RepasPage');
const RepasActivitePage = page(gestion, 'RepasActivitePage');
const CommandesPage = page(gestion, 'CommandesPage');
const RepasActivite = lazy(() =>
  gestion().then((m) => ({
    default: ({ activityId }: { activityId: string }) => (
      <m.RepasActivite activityId={activityId} embedded />
    ),
  })),
);
const FournisseursPage = page(() => import('./FournisseursPage.js'), 'FournisseursPage');

export const repasWeb: ModuleWeb = {
  module: 'repas',
  routes: [
    { path: '/repas/mon-repas', element: <MesRepasPage /> },
    { path: '/repas/mon-repas/:activityId', element: <MonRepasPage /> },
    { path: '/repas', element: <RepasPage /> },
    { path: '/repas/activite/:activityId', element: <RepasActivitePage /> },
    { path: '/repas/commandes', element: <CommandesPage /> },
    { path: '/repas/fournisseurs', element: <FournisseursPage /> },
  ],
  // Les repas se gèrent dans la fiche de l'activité (onglet « Repas ») ; la page
  // `/repas/activite/:id` reste disponible.
  activityTabs: [
    {
      key: 'repas',
      label: 'Repas',
      render: (activityId) => (
        <Suspense fallback={<Loading />}>
          <RepasActivite activityId={activityId} />
        </Suspense>
      ),
    },
  ],
};
